import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { getTaavonBackendAddress } from "../../../utils/getTaavonBackendAddress";

export const mainGetStewards = createAsyncThunk(
  "GET_STEWARDS",
  async (province) => {
    const axiosInstance = axios.create();

    const apiUrl = `${getTaavonBackendAddress(
      province
    )}total_guilds_for_inspection/`;

    try {
      const response = await axiosInstance.get(apiUrl);
      const { data, status } = response;
      return { data, status };
    } catch (error) {
      // Handle error if needed
      console.error("Error fetching data:", error);
      throw error;
    }
  }
);
